import React, { useState } from "react";
import axios from "axios";
import "../style/weather.css";
import WeatherCard from "../components/weatherCard";
import Welcome from "../components/welcome";
import Loading from "../components/loading";
import Error from "../components/error";

function Biografia() {
  // code to take information about wheather API
  const [data, setData] = useState();
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [cityNameToError, setCitynameToError] = useState("");

  const apiKeyOpenWeather = process.env.REACT_APP_OPENWEATHER_API_KEY;
  // function to search data fromn API
  const wheatherData = async (parameters) => {
    setLoading(true);
    setError(false);
    try {
      const response = await axios.get(
        `https://api.openweathermap.org/data/2.5/forecast?q=${parameters}&appid=${apiKeyOpenWeather}`
      );
      setData(response.data);
    } catch (error) {
      console.error("Non è partito il try FrontMsg", error);
      if (error.response && error.response.status === 404) {
        setError(true);
        if (error) {
          setCitynameToError(search);
        }
      }
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 1500);
    }
  };

  // Function connect to button search
  const searching = () => {
    if (search) {
      wheatherData(search);
    }
  };
  // function to start searching with enter key
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      wheatherData(search);
    }
  };
  return (
    <>
      <div className="weatherContainer">
        <div className="sectionSearch">
          <section className="inputBtnContainer">
            <div>
              <input
                type="text"
                placeholder="City name"
                value={search}
                onChange={(e) => setSearch(e.target.value.toLocaleUpperCase())}
                required
                onKeyDown={handleKeyPress}
                maxLength={58}
              />
            </div>
            <div>
              <button className="btnSearchWeather" onClick={searching}>
                Search
              </button>
            </div>
          </section>
        </div>
        {/* section to error message */}
        <section>
          {loading ? (
            <Loading />
          ) : error ? (
            <section>
              <Error data={data} cityError={cityNameToError} />
              {/* <h1>
                Sorry! {cityNameToError} is not found or is out of wheather
                radar
              </h1> */}
            </section>
          ) : (
            <section>
              {data ? (
                <>
                  <WeatherCard data={data} />
                </>
              ) : (
                <Welcome />
              )}
            </section>
          )}
        </section>
      </div>
    </>
  );
}

export default Biografia;
